import request from '@/utils/request'

export function index(params) {
    return request({
        url: 'visitors/guest_car_models',
        method: 'get',
        params: params
    })
}

export function inventory(params) {
    return request({
        url: 'visitors/guest_car_model/inventory',
        method: 'get',
        params: params
    })
}

export function show(id) {
    return request({
        url: `/visitors/guest_car_models/${id}`,
        method: 'get'
    })
}

export function store(data) {
    return request({
        url: `visitors/guest_car_models`,
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: `visitors/guest_car_models/${data.id}`,
        method: 'put',
        data
    })
}

export function destroy(data) {
    return request({
        url: `visitors/guest_car_models/${data.id}`,
        method: 'delete',
    })
}
